import React from 'react'
import { CloseIconSvg } from './Svgs'
import greenTick from '../../assets/images/green_tick.svg'
import redCrossIcon from '../../assets/images/redCroshIcon.svg'
import { setIsTipsForBestResults } from '../../redux/onBoardingSlice'
import { useDispatch, useSelector } from 'react-redux'
import disclaimers from '../../assets/images/dangerSvg.svg'
import { setIsOpenTermsAndConditionsModal } from '../../redux/imageModalSlice'
import { setTermsAndConditions } from '../../redux/authSlice'

const TipsForBestResults = () => {
    const dispatch = useDispatch()

    const { isTipsForBestResults } = useSelector((state) => state.onBoarding);
    const { isVisualizePageVisible } = useSelector((state) => state.createImage);

    const termsAndConditions = () => {
        dispatch(setIsTipsForBestResults(false))
        if (isVisualizePageVisible && window.location.pathname === '/generate-image') {
            dispatch(setTermsAndConditions(true))
        } else {
            dispatch(setIsOpenTermsAndConditionsModal(true))
        }
    }

    const TipsContents = [
        {
            title: 'Want a "specific" text in image?',
            description: 'Mark the exact text or words you want in your designs with "Double quotes"',
            correctPrompt: 'Vintage travel poster of brand “Classic” with warm, muted colors',
            wrongPrompt: 'Vintage travel poster'
        },
        {
            title: 'Define key elements you want.',
            description: 'Mention objects, people, or environments you want in your image.',
            correctPrompt: 'A cozy bookstore with wooden shelves and a cat sleeping on the counter',
            wrongPrompt: 'A cozy bookstore'
        },
        {
            title: 'Add emotions & atmosphere.',
            description: 'Set the mood with adjectives you want your design to bring out.',
            correctPrompt: 'Dramatic and intense portrait with a stormy background',
            wrongPrompt: 'Portrait'
        },
    ]

    return (
        <>
            <div className={`z-[98] fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300
             ${isTipsForBestResults ? "opacity-100 visible" : "opacity-0 invisible"}`}
                onClick={() => dispatch(setIsTipsForBestResults(false))}
            />

            <div className={`overflow-y-scroll overflow-x-hidden z-[99] fixed top-0 right-0 h-screen w-[520px] bg-white shadow-lg transition-transform duration-300 ${isTipsForBestResults ? "translate-x-0" : "translate-x-full"}`}>
                <div className='sticky top-0 z-[999] bg-white h-[72px] px-[32px] flex justify-between items-center border-b'>
                    <h2 className='text-[19px] leading-[24px] font-helveticaText-Medium'>Tips for best results.</h2>
                    <CloseIconSvg className="cursor-pointer" onClick={() => dispatch(setIsTipsForBestResults(false))} />
                </div>

                <div className="">
                    {TipsContents.map((tip, index) => (
                        <div key={index} className='border-b py-[24px]'>
                            <div className="w-fit flex flex-col gap-[8px] px-[32px] ">
                                <h3 className="font-helveticaText-Medium">{tip.title}</h3>
                                <p className="text-[13px] w-[461px]">{tip.description}</p>
                            </div>
                            <div className="flex flex-col gap-[16px] mt-2 px-[32px] ">
                                <div className='flex items-center gap-[8px]'>
                                    <p className="w-fit px-[12px] py-[8px] bg-[#F8FBF9] border-1 border-[#26A568] rounded-[8px] text-[13px]">
                                        {tip.correctPrompt}
                                    </p>
                                    <img src={greenTick} alt="" />
                                </div>
                                <div className='flex items-center gap-[8px]'>
                                    <p className="w-fit px-[12px] py-[8px] bg-[#FCFCFD] border-1 border-[#C3CAD4] rounded-[8px] text-[13px]">
                                        {tip.wrongPrompt}
                                    </p>
                                    <img src={redCrossIcon} alt="" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className='p-[24px] flex flex-col gap-[8px]'>

                    <div className='flex gap-[8px]'>
                        <img src={disclaimers} alt="" className='h-[14px] w-[14px]' />
                        <h3 className='text-[13px] font-helveticaText-Bold'>Disclaimer</h3>
                    </div>
                    <p className='text-[13px] text-[#667488]'>AI-generated visualizations aim to closely replicate original fonts; however, slight variations may occur.</p>
                    <h5 className='text-[13px] leading-[16px] text-[#667488] text-justify' >
                        Portrait is designed to inspire users by showing how fonts look in visual settings. The main text reflects the chosen font, while smaller text may appear unreadable.
                        Please refer to our <a href='/terms-and-conditions' target="_blank" rel="noopener noreferrer" className='text-blue-primary '>
                            terms and conditions &nbsp;
                        </a>for more details on image usage guidelines.
                    </h5>
                </div>
            </div>


        </>
    )
}

export default TipsForBestResults